<template>
  <div class="login-container">
    <!-- 外层容器添加居中对齐样式 -->
    <div :style="{width: isMobile() ? '90%' : '30%', margin: '100px auto'}" class="login-wrapper">
      <el-card class="login-card">
        <h2 style="text-align: center; margin-bottom: 30px; font-size: 24px;">数字资源平台</h2>
        <!-- @keyup.enter事件监听 -->
        <avue-form ref="form" v-model="data" :option="option" @submit="submit" @keyup.enter.native="handleEnterKey" class="login-form">
          <template slot-scope="{size}" slot="menuForm">
            <el-button
                style="width: 100%; margin: 10px 0;"
                type="primary"
                :size="size"
                @click="$refs.form.submit()"
            >
              登录
            </el-button>
          </template>
        </avue-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { setLocal, getLocal, checkLocal } from '@/utils/localstorage.js';
export default {
  data() {
    return {
      codeSrc: '',
      role: '1',
      data: {
        username: '',
        password: '',
        companyCode: '',
        code: '',
        role: 1
      },
      option: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '账号',
            prop: 'username',
            span: 24,
            rules: [
              {required: true, message: "请输入账号", trigger: "blur"}
            ]
          },
          {
            label: '密码',
            prop: 'password',
            type: 'password',
            span: 24,
            rules: [
              {required: true, message: "请输入密码", trigger: "blur"}
            ]
          }
        ]
      }
    }
  },
  mounted() {
    // 给整个页面添加键盘事件监听
    document.addEventListener('keyup', this.handleDocumentKeyup);
  },
  beforeDestroy() {
    // 组件销毁时移除事件监听，防止内存泄漏
    document.removeEventListener('keyup', this.handleDocumentKeyup);
  },
  methods: {
    // 判断是否是手机端
    isMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    },
    submit(form, done) {
      // 登录成功后存储
      const successInfo = {
        "workNo": "EMP123456", // 员工工号（关键字段，用于接口调用）
        "workName": "利群集团",     // 员工姓名（用于显示头像首字母）
        "userId": "10001",      // 用户ID（唯一标识）
        "role": "admin",        // 角色权限（如管理员/普通用户）
        "department": "技术部", // 所属部门
        "loginTime": "2024-05-20T08:30:00Z", // 登录时间
        "expireTime": "2024-05-20T20:30:00Z" // 登录过期时间
      };
      localStorage.setItem('successInfo', JSON.stringify(successInfo));
      if(form.username === 'liqun' && form.password === '191994'){
        this.$router.push('/infoManagement/informationEdit');
      } else {
        this.$message.error('用户或者密码错误')
      }

        done();
    },
    // 处理表单内的Enter键事件
    handleEnterKey() {
      this.$refs.form.submit();
    },
    // 处理整个文档的Enter键事件
    handleDocumentKeyup(e) {
      // 当按下Enter键时触发登录
      if (e.key === 'Enter' || e.keyCode === 13) {
        this.$refs.form.submit();
      }
    }
  }
}
</script>

<style scoped>
/* 原有样式保持不变 */
.login-container {
  width: 100%;
  height: 100vh; /* 使用视窗高度确保全屏背景 */
  background-image: url('~@/assets/img/backgroudImg/background.png');
  background-size: cover; /* 背景图自适应 */
  background-position: center; /* 背景图居中 */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.login-wrapper {
  max-width: 400px; /* 限制最大宽度 */
  width: 100%;
}

.login-card {
  padding: 30px 25px; /* 卡片内边距 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* 轻微阴影提升层次感 */
  border-radius: 8px;
}

.login-form {
  /* 确保表单内部元素居中 */
  display: flex;
  flex-direction: column;
  gap: 15px; /* 表单项间距 */
}

/* 验证码输入框样式优化 */
.code-input-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
}

/* 解决Element UI输入框与图片的间距问题 */
::v-deep .el-input-group__append {
  padding: 0 !important;
  border-left: none !important;
}

/* 调整表单项标签与输入框的对齐 */
::v-deep .el-form-item__label {
  text-align: right;
  padding-right: 10px;
}

/* 移动端适配调整 */
@media screen and (max-width: 768px) {
  .login-card {
    padding: 20px 15px;
  }

  ::v-deep .el-form-item__label {
    text-align: left;
    padding-bottom: 5px;
  }

  /* 移动端验证码输入框占比调整 */
  .code-input {
    flex: 2; /* 移动端输入框占比更大 */
  }

  /* 移动端验证码图片宽度调整 */
  .code-input-wrapper .el-image {
    width: 90px !important;
  }

  /* 解决Element UI输入框内部间距问题 */
  ::v-deep .el-input__inner {
    padding: 0 10px !important;
  }

  /* 确保输入框组占满宽度 */
  ::v-deep .el-input-group {
    width: 100% !important;
  }
}

/* 验证码输入框样式优化 */
.code-input-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
}

/* 为验证码输入框设置基础宽度，移动端自适应 */
.code-input {
  flex: 1; /* 默认让输入框占据剩余空间 */
}
</style>